module.exports = __webpack_public_path__ + "img/dw_4.172988b9.png";